import React from 'react'

import MobileFactoryCycleTimeMonitoring from './MobileFactoryCycleTimeMonitoring'

const id = 'tpi.dataViewers.MobileFactoryCycleTimeMonitoringSupportDataViewer'

export default {
  id,
  type : 'tpi.MobileFactoryCycleTimeMonitoringSupportDataViewer',
  name : 'Mobile - Cycle Time Monitoring',
  icon : 'fa-solid fa-grid-2',
  location : [ 'main', 'card' ],
  matches : {
    type : [ 'GroupDataViewer', 'ItemInfoDataViewer' ],
    objectType : 'location',
  },
  createSettings : ( props ) => {
    return {
      type : 'tpi.MobileFactoryCycleTimeMonitoring',
      queryName : 'molds.search',
    }
  },
  render : ( props ) => {
    return React.createElement( MobileFactoryCycleTimeMonitoring, props )
  },
  getDefaultCardContentOptions : { height : 'auto' },
}
